import React from 'react'
import { ButtonGroup } from '@chakra-ui/react'

export default (props) => {
  return <ButtonGroup {...props} />
}
